import * as React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
import CircularProgress from "@mui/material/CircularProgress";
import { LoadingButton } from '@mui/lab';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
// import { userLogin } from "../../../Redux/User/UserAction";
// import { login } from "../../../Services/AuthService/AuthService";

import "./Login.css";

const validationSchema = yup.object({
  email: yup
    .string()
    .email("Introduzca un email valido. Ej: ejemplo@gmail.com")
    .required("Este campo es requerido"),
  password: yup
    .string()
    .min(8, "La contraseña debe ser de al menos 8 caracteres")
    .required("La contraseña es requerida"),
});

export default function LoginForm(props: any) {
  const history = useHistory();
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: null,
    onSubmit: async (values) => {
      instance
        .loginRedirect(loginRequest)
        .then((response) => console.log("login", response))
        .catch((e) => {
          console.error(e);
        });
    },
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div></div>

        <LoadingButton
          color="primary"
          style={{
            backgroundColor: "var(--blue-lis)",
            fontFamily: "var(--lis-title)",
          }}
          variant="contained"
          fullWidth
          loadingIndicator={<CircularProgress size={16} />}
          loading={isLoading}
          type="submit"
        >
          Entrar
        </LoadingButton>
      </form>
    </>
  );
}
